import React from 'react';
import '../Styles/Introduction.css';
import Lottie from 'lottie-react';
import anime1 from '../animations/anime1.json';
import anime2 from '../animations/anime2.json';
import anime3 from '../animations/anime6.json';
import anime4 from '../animations/anime4.json';
import anime5 from '../animations/anime7.json';
import {Link} from "react-router-dom";
import {useNavigate} from "react-router-dom";




const Introduction = () => {
    const navigate = useNavigate();
    return (
        <div className="home-intro">

            {/* Hero Section */}
            <section className="hero">
                <div className="typewriter">
                    <h2 style={{color: 'black'}}> Sanal Gerçeklik destekli sürükleyici eğitimler ile öğrenmeyi bir deneyime dönüştürelim.</h2>
                </div>
            </section>

            {/* About Section */}
            <section className="about">
                <h2>MeduVr Nedir?</h2>
                <p>
                    MeduVR, hedef gruplara yönelik simülasyonlar ve VR teknolojisi ile geliştirilmiş içerikler
                    içeren Türkiye’nin ilk ve tek sanal gerçeklik tabanlı eğitim uygulamasıdır. Bu uygulama,
                    "Tıbbi Görüntüleme Teknikleri programı öğrencilerine", "sağlık profesyonellerine", "üniversite
                    öğrencilerine", "topluma" ve "tıbbi görüntüleme cihaz profesyonellerine" yönelik kapsamlı eğitim
                    içerikleri sunmaktadır.
                </p>
                {/* <Lottie animationData={anime1} loop={true} className="intro-animation"/> */}
                <Lottie animationData={anime2} loop={true} className="features-animation"/>
            </section>

            {/* Features Section */}
            <section className="features">
                <div className="features-grid">
                    <div className="feature-item">
                        <span>🧠</span>
                        <h3>İnteraktif Öğrenme</h3>
                        <p>Eğitimi unutulmaz kılan simülasyonlar aracılığıyla etkileşim kurun.</p>
                    </div>
                    <div className="feature-item">
                        <span>🌍</span>
                        <h3>Erişim Kolaylığı</h3>
                        <p>İstediğiniz zaman istediğiniz yerden içeriklere erişin.</p>
                    </div>
                    <div className="feature-item">
                        <span>📊</span>
                        <h3>İlerleme Takibi</h3>
                        <p>Kurs sonu değerlendirme testleri ile ilerlemenizi görün</p>
                    </div>
                </div>

            </section>

            {/* How It Works */}
            <section className="how-it-works">
                <Lottie animationData={anime4} loop={true} className="testimonials-animation"/>
                <h2>Derslere Nasıl Erişirsin?</h2>

                <div className="steps">
                    <div className="step">
                        <h3>1. Kullanıcı Girişi</h3>
                        <p>Ders içeriklerine erişebilmek için kullanıcı girişi yapmalısın. Eğer hesabın yoksa hemen
                            oluşturabilirsin.</p>
                        <button className="login-button" onClick={() => navigate('/signin')}>Giriş Yap</button>
                        <button className="login-button" onClick={() => navigate('/signup')}>Hesap Oluştur</button>
                    </div>
                    <div className="step">
                        <h3>2. Dilediğin Kursa Kayıt Ol</h3>
                        <p>Giriş yaptıktan sonra kurslar bölümünden katılmak istediğin kursu seçip kayıt yapmalısın.</p>
                        <button className="courses" onClick={() => navigate('/courses')}>Kurslar</button>
                    </div>
                    <div className="step">
                        <h3>3. Derslere Başla</h3>
                        <p>Artık hazırsın!
                            <br/>
                            Kurs sayfasında ders içeriğini gör butonunu kullanarak içeriklere ulaşabilirsin.</p>
                    </div>
                </div>
                {/*<Lottie animationData={anime3} loop={true} className="how-it-works-animation"/>*/}
            </section>

            {/* Testimonials
            <section className="testimonials">
                <h2>What People Say</h2>
                <div className="testimonial-cards">
                    <div className="card">
                        <p>"MeduVr made our anatomy classes come alive—literally. Game changer!"</p>
                        <span>- Dr. Aylin, Biology Educator</span>
                    </div>
                    <div className="card">
                        <p>"I finally understood the solar system—thanks to a VR field trip!"</p>
                        <span>- Can, Middle School Student</span>
                    </div>
                </div>

            </section>

            {/* CTA Footer
            <section className="cta-footer">
                <h2>Start Your VR Learning Journey Today</h2>
                <button className="cta-button">Get Started</button>
                <Lottie animationData={anime5} loop={true} className="cta-animation"
                        style={{width: '20%', height: '20%'}}/>
            </section>
            */}
        </div>
    );
};

export default Introduction;